// removed by extract-text-webpack-plugin
module.exports = {"menuText":"#8C8FA5","menuActiveText":"#5D8C82","subMenuActiveText":"#5D8C82","menuBg":"#fff","menuHover":"#fff","subMenuBg":"#fff","subMenuHover":"#fff","sideBarWidth":"268px"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/variables.scss
// module id = 1009
// module chunks = 72